import React from 'react';
import { KoobBadge } from '@koob/ui';
import { BookingSourceAbbreviationEnum } from '@koob/enums';

export interface FolderBookingSourceBadgeProps {
  /** TD (booked in a trip) or MKP (standalone). */
  source: string;
}

/** KD-3842: where a service was booked from, Trip Designer or marketplace. */
export default function FolderBookingSourceBadge({
  source,
}: FolderBookingSourceBadgeProps) {
  return (
    <KoobBadge
      color={
        source === BookingSourceAbbreviationEnum.TRIP_DESIGNER
          ? 'purple'
          : 'blue'
      }
    >
      <span className="min-w-[44px] text-center uppercase">{source}</span>
    </KoobBadge>
  );
}
